import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import {
  getInitials,
  markAsRead,
  formatTimeAgo,
} from './utils/notificationService'
import { notifyError, notifySuccess } from '../../../../utils/toast'
import {
  NotificationItemContainer,
  NotificationItemTimestamp,
  NotificationItemTitle,
  NotificationItemUnreadDot,
  NotificationsPageAvatarContainer,
} from './styled'
import DOMPurify from 'dompurify'

const NotificationItem = React.memo(({ notification, onMarkAsRead }) => {
  const { t } = useTranslation()

  const handleMarkAsRead = useCallback(async () => {
    if (notification.read) return

    try {
      const success = await markAsRead(notification.id)
      if (success) {
        onMarkAsRead(notification.id)
        notifySuccess(t('notifications.markAsReadSuccess'))
      }
    } catch (error) {
      notifyError(t('notifications.markAsReadFailed'))
    }
  }, [notification.id, notification.read, onMarkAsRead, t])

  return (
    <NotificationItemContainer
      read={notification.read}
      onClick={handleMarkAsRead}
    >
      <NotificationsPageAvatarContainer size={46}>
        <span>{getInitials(notification.title)}</span>
      </NotificationsPageAvatarContainer>
      <div style={{ flex: 1, minWidth: 0 }}>
        <NotificationItemTitle read={notification.read}>
          {notification.title}
        </NotificationItemTitle>
        <div
          className="notification-message-content p-0"
          style={{
            fontSize: '0.75rem',
            color: '#6b7280',
            marginTop: '0.25rem',
          }}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(notification?.message || ''),
          }}
        />
        <NotificationItemTimestamp>
          {formatTimeAgo(notification.date || notification.timestamp)}
        </NotificationItemTimestamp>
      </div>
      {!notification.read && <NotificationItemUnreadDot />}
    </NotificationItemContainer>
  )
})

NotificationItem.propTypes = {
  notification: PropTypes.object.isRequired,
  onMarkAsRead: PropTypes.func.isRequired,
}

export default NotificationItem
